import React, { useState, useEffect } from 'react';
import './Pages.css';
import emailjs from '@emailjs/browser';
import { getFirestore } from "firebase/firestore";
import { collection, addDoc } from "firebase/firestore";

const ContactUs = () => {
  useEffect(() => {
    // Initialize EmailJS
    emailjs.init("clRRNNd3REPot0LYV");
  }, []);

  const [contactForm, setContactForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const [contactSubmitted, setContactSubmitted] = useState(false);
  const [contactError, setContactError] = useState(null);

  const handleContactChange = (e) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactError(null);

    // Basic validation
    if (!contactForm.firstName || !contactForm.email || !contactForm.message) {
      setContactError('Please fill in all required fields');
      return;
    }

    try {
      const db = getFirestore();
      
      // First, store in Firebase
      await addDoc(collection(db, "contact-messages"), {
        ...contactForm,
        timestamp: new Date()
      });

      // Then send email using EmailJS
      const templateParams = {
        to_email: 'contact@travspresents.tv',
        from_name: `${contactForm.firstName} ${contactForm.lastName}`,
        from_email: contactForm.email,
        phone: contactForm.phone,
        message: contactForm.message,
        reply_to: contactForm.email // Add reply_to field
      };

      await emailjs.send(
        'service_7azmxub',
        'template_0yhursg',
        templateParams,
        'clRRNNd3REPot0LYV'
      );
      
      setContactSubmitted(true);
      setContactForm({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
      });

      // Reset form after 3 seconds
      setTimeout(() => {
        setContactSubmitted(false);
      }, 3000);
    } catch (error) {
      console.error("Error submitting contact form:", error);
      setContactError('Failed to send message. Please try again.');
    }
  };

  return (
    <div className="page-container">
      <div className="page-content">
        {/* <h1>CONTACT US</h1> */}
        <div className="contact-form-container">
          <form onSubmit={handleContactSubmit}>
            <div className="contact-form-row">
              <input 
                type="text" 
                name="firstName"
                className="contact-input" 
                placeholder="FIRST NAME *" 
                value={contactForm.firstName}
                onChange={handleContactChange}
              />
              <input 
                type="text" 
                name="lastName"
                className="contact-input" 
                placeholder="LAST NAME" 
                value={contactForm.lastName}
                onChange={handleContactChange}
              />
            </div>
            <div className="contact-form-row">
              <input 
                type="email" 
                name="email"
                className="contact-input" 
                placeholder="EMAIL ADDRESS *" 
                value={contactForm.email}
                onChange={handleContactChange}
              />
              <input 
                type="tel" 
                name="phone"
                className="contact-input" 
                placeholder="PHONE NUMBER" 
                value={contactForm.phone}
                onChange={handleContactChange}
              />
            </div>
            <div className="contact-form-row single">
              <textarea 
                name="message"
                className="contact-textarea" 
                placeholder="TYPE YOUR MESSAGE HERE *"
                value={contactForm.message}
                onChange={handleContactChange}
              ></textarea>
            </div>
            {contactError && (
              <div className="contact-error">
                {contactError}
              </div>
            )}
            {contactSubmitted && (
              <div className="contact-success">
                Message sent successfully!
              </div>
            )}
            <div className="contact-form-row">
              <button type="submit" className="contact-submit-button">
                SEND MESSAGE
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs; 